import { withoutTrailingSlash } from "healthex-common/utils";
export function normalizeHostedRedirectUrl(url) {
    try {
        const parsed = new URL(url);
        const normalizedPath = `${withoutTrailingSlash(parsed.pathname)}/`;
        return `${parsed.protocol}//${parsed.host.toLowerCase()}${normalizedPath}${parsed.search}`;
    }
    catch (e) {
        console.warn("[HostedFlow] Invalid URL:", url, e);
        return null;
    }
}
export function isHostedRedirectUriAllowed(redirectUri, allowedUrls) {
    const normalizedInput = normalizeHostedRedirectUrl(redirectUri);
    if (!normalizedInput)
        return false;
    return allowedUrls.some((allowedUrl) => {
        if (allowedUrl.endsWith("/*")) {
            const normalizedBase = normalizeHostedRedirectUrl(allowedUrl.slice(0, -1));
            if (!normalizedBase)
                return false;
            return normalizedInput.startsWith(normalizedBase);
        }
        return normalizeHostedRedirectUrl(allowedUrl) === normalizedInput;
    });
}
export function buildHostedRedirectUrl(redirectUri, params) {
    const url = new URL(redirectUri);
    url.searchParams.set("status", params.status);
    if (params.patientId) {
        url.searchParams.set("patientId", params.patientId);
    }
    if (params.xid) {
        url.searchParams.set("xid", params.xid);
    }
    return url.toString();
}
